import React from "react";
import Image from "next/image";
import { cn } from "@/lib/utils";

import dotsLeft from "@/public/lp-long/dots-left.svg";
import dotsRight from "@/public/lp-long/dots-right.svg";

/** Pixel-dots pattern at the top of a section, fading out toward the sides. */
export default function DotsBackdrop({
  className,
  light = false,
  width = "119.875rem",
  height = "25.25rem",
}: {
  className?: string;
  /** invert the dark dots for use on dark backgrounds */
  light?: boolean;
  /** overall width of the pattern; matches the Figma frame it's used in */
  width?: string;
  /** height of the pattern; matches the Figma frame it's used in */
  height?: string;
}) {
  return (
    <div
      className={cn(
        "pointer-events-none absolute top-0 left-1/2 flex -translate-x-1/2 opacity-50",
        light && "invert",
        className,
      )}
      style={{
        width,
        maskImage:
          "linear-gradient(to right, transparent 0%, black 25%, black 75%, transparent 100%)",
        WebkitMaskImage:
          "linear-gradient(to right, transparent 0%, black 25%, black 75%, transparent 100%)",
      }}
      aria-hidden
    >
      <div
        className="flex w-1/2 items-center justify-center overflow-clip"
        style={{ height }}>
        <Image
          className="!max-w-none rotate-90"
          style={{ width: height }}
          src={dotsLeft}
          alt=""
        />
      </div>
      <div
        className="flex w-1/2 items-center justify-center overflow-clip"
        style={{ height }}>
        <Image
          className="!max-w-none -rotate-90"
          style={{ width: height }}
          src={dotsRight}
          alt=""
        />
      </div>
    </div>
  );
}
